import React, { useState, useEffect, useContext } from "react";
import NavButton from "../../components/NavButton/index";
import LoaderAnim from "../../components/LoaderAnim/index";
import ContentHeader from "../../components/ContentHeader/index";
import FormInput from "../../components/FormInputs/FormInput";
import { useDataApi, API } from "../../components/API/index";
import { parseGeonames } from "../../utils/index";
import MsmContext, { Actions } from "../../reducers/Context";
import useDebounce from "../../hooks/useDebounce";

const TeamLocation = props => {
  const { dispatch, state } = useContext(MsmContext);
  const [searchFor, setSearchFor] = useState(state.locationSearchTerm || "");
  const debouncedSearchTerm = useDebounce(searchFor, 500);

  const { data, isLoading, isError, doFetch } = useDataApi("", {
    teams: []
  });

  useEffect(() => {
    if (debouncedSearchTerm && debouncedSearchTerm.length >= 3) {
      doFetch(`${API.SEARCH_GEONAMES}?searchFor=${debouncedSearchTerm}`);
      dispatch({
        type: Actions.SEARCHED_FOR_LOCATION_NAME,
        payload: { locationName: debouncedSearchTerm }
      });
    }
  }, [debouncedSearchTerm]);

  const didSelectLocation = location => {
    //console.log("selected", location);
    dispatch({
      type: Actions.SELECTED_LOCATION,
      payload: { location }
    });
  };

  useEffect(() => {
    //console.log("got data", data);
  }, [data]);

  return (
    <>
      <ContentHeader
        text="Where is your team from?"
        icon="map103"
        iconFill="teal"
        iconSize="25"
      />

      <div className="afs-msm-input-holder afs-msm-sticky add-all-padding">
        <FormInput
          type="text"
          value={searchFor}
          onChange={event => setSearchFor(event.target.value)}
          label="Search for your nearest town, city or area"
          helper="Your location is used to enhance many TeamStats features"
          placeholder="Minimum 3 characters"
        />
      </div>
      <div className="afs-msm-stage-content has-sticky-header">
        {isError && <div>Something went wrong ...</div>}

        {isLoading ? (
          <LoaderAnim />
        ) : (
          <ul>
            {data.geonames &&
              parseGeonames(data.geonames).map(location => {
                return (
                  <LocationResult
                    selected={() => {
                      didSelectLocation(location);
                    }}
                    key={location.TeamGeonameID}
                    flag={location.TeamFlagUrl}
                    town={location.TeamTown}
                    county={location.TeamCounty}
                    country={location.TeamCountry}
                  />
                );
              })}
            {data.geonames && !data.geonames.length && (
              <p className="add-all-padding">
                No results, please amend your search term
              </p>
            )}
          </ul>
        )}
      </div>
      <div className="afs-msm-stage-action-buttons">
        <NavButton text="BACK" actionType={Actions.PREV_STAGE} />
      </div>
    </>
  );
};

const LocationResult = props => {
  return (
    <li
      onClick={props.selected}
      className="afs-msm-location-search-result add-all-padding"
    >
      <img
        className="afs-msm-location-search-result-flag"
        src={props.flag}
        alt="location-flag"
      />
      <div>
        <div className="town">
          <b>{props.town}</b>
        </div>
        <div className="county">{props.county}</div>
        <div className="country">{props.country}</div>
      </div>
    </li>
  );
};

export default {
  id: "team-location",
  title: "Sign up to TeamStats",
  subtitles: [
    "Thousands of teams from 162 countries are already using TeamStats."
  ],
  imageUrl:
    "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-1.jpg",
  component: TeamLocation
};
